import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { TipoClassificacaoPipeModule } from '../pipes';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { TipoClassificacaoMultiselectComponent } from './tipo-classificacao-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        TipoClassificacaoPipeModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        TipoClassificacaoMultiselectComponent
    ],
    exports: [
        TipoClassificacaoMultiselectComponent
    ]
})
export class TipoClassificacaoMultiselectModule { }
